export default __webpack_public_path__ + "static/media/sprout-tree-svgrepo-com.6b8db03a.svg";